var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.659 12.8473L17.2281 16.4157L16.049 17.5948L12.4806 14.0257C11.1529 15.09 9.50147 15.6689 7.79981 15.6665C3.6598 15.6665 0.299805 12.3065 0.299805 8.1665C0.299805 4.0265 3.6598 0.666504 7.79981 0.666504C11.9398 0.666504 15.2998 4.0265 15.2998 8.1665C15.3022 9.86817 14.7233 11.5196 13.659 12.8473ZM11.9873 12.229C13.0449 11.1414 13.6355 9.68353 13.6331 8.1665C13.6331 4.94317 11.0223 2.33317 7.79981 2.33317C4.57647 2.33317 1.96647 4.94317 1.96647 8.1665C1.96647 11.389 4.57647 13.9998 7.79981 13.9998C9.31683 14.0022 10.7747 13.4116 11.8623 12.354L11.9873 12.229Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.4a7c7e9c9df6507e4db5432e023feda6.svg";
export { ForwardRef as ReactComponent };